import { TaskStatusLabel, TaskStatusTabRelation } from 'constants/tasks';

import { removeExcessiveSpaces } from './string';

// The backend status enum outgrows these maps over time, so an unmapped status falls
// back to the raw server value rather than rendering an empty cell.
export const getTaskStatusLabel = status => TaskStatusLabel[status] ?? status ?? null;

export const getTaskStatusTabLabel = status => TaskStatusTabRelation[status] ?? status ?? null;

export const checkIsTaskItemInvalid = ({ items, value, fieldName, initialValue }) => {
  const valueToCompare = removeExcessiveSpaces(value);

  return !!items.find(
    item => item[fieldName] === valueToCompare && initialValue !== valueToCompare,
  );
};
